import React from "react";
import { useApp } from "../contexts/AppContext";

// Renders an i18n text value as sanitized HTML (supports admin formatting:
// bold, italic, underline, size, color, lists, links, alignment).
export default function RichText({ k, fallback = "", as: Tag = "span", className, ...rest }) {
  const { tHtml } = useApp();
  const richCls = "[&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_a]:text-blue-600 [&_a]:underline";
  return <Tag className={[className, richCls].filter(Boolean).join(" ")} dangerouslySetInnerHTML={{ __html: tHtml(k, fallback) }} {...rest} />;
}
